import { Injectable } from '@angular/core';
import { Observable, of, throwError, timer } from 'rxjs';
import { catchError, switchMapTo, take } from 'rxjs/operators';
import { IPC_CHANNEL } from '../../_offline/electron.constants';
import { UserProfileSchema } from '../../_offline/models/user-profile.schema';
import { ElectronService } from '../../electron.service';

@Injectable({
  providedIn: 'root'
})
export class UserProfileDbService {

  constructor(protected electronService: ElectronService) { }

  get(userId: string): Observable<UserProfileSchema>  {
    return this.ipcSendSync(IPC_CHANNEL.USER_PROFILE.GET_ONE, userId);
  }

  put(userProfile: UserProfileSchema): Observable<UserProfileSchema> {
    return this.ipcSendSync(IPC_CHANNEL.USER_PROFILE.PUT_ONE, userProfile);
  }

  protected ipcSendSync(channel: string, ...args: any[]) {
    const sendSyncOf = of(this.electronService.sendSyncCommand(channel, ...args));
    return timer(50)
      .pipe(switchMapTo(sendSyncOf))
      .pipe(take(1))
      .pipe(catchError((error: any) => throwError(() => error.json)));
  }
}
